import {useCallback} from 'react';
import {useUserInfo} from '../../derived/userInfo';
import {useSettings} from './useSettings';
import {useSettingsActions} from './useSettingsActions';

/**
 * Updates the list of favourite members in the settings data structure.
 * The list of favourite members is limited to three members, and will
 * contain the identifier (memberShipId) of members in the list
 */
export const useFavouriteMembers = () => {
  const userInfo = useUserInfo();
  const settings = useSettings(userInfo?.userid ?? 0);
  const {update} = useSettingsActions();
  const addFavouriteMember = useCallback(
    (memberId: number) => {
      const nextFavourites = [memberId].concat(
        ...(settings?.favouriteMembers ?? [])
          .filter(p => p !== memberId)
          .slice(0, 2),
      );
      update(userInfo?.userid ?? 0, {
        favouriteMembers: nextFavourites,
      });
    },
    [settings?.favouriteMembers, update, userInfo?.userid],
  );

  return {
    favouriteMembers: settings?.favouriteMembers ?? [],
    addFavouriteMember,
  };
};
